import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Register',
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message:"",
            disable_btn:false,
            loading:false,
            action_loading:false,
            activate_token:false,
            set_forgot_password: false,
            reset_password:false,
            display_reset_password_form: false,
            data_processing_message: "",
            set_cta:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
    },
    computed:{
        checkPasswordMatch(){
            this.data_processing_message = "";
            if(((this.user.new_password != '') && (this.user.new_password != undefined)) && ((this.user.confirm_password != '') && (this.user.confirm_password != undefined))) {
                if(this.user.new_password != this.user.confirm_password){
                    this.data_processing_message = "Password does not match";
                }else{this.data_processing_message = "";}
            }else{this.data_processing_message = "";}
        }
    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == 'forgot'){
                this.set_forgot_password = true;
            }
            if(attr1 == 'login'){
                this.set_forgot_password = false;
            }
            if(attr1 == 'reset'){
                this.reset_password = true;
                this.loading = true;
                this.verifyResetToken();
            }
            if(attr1 == 'activate'){
                this.activate_token = true;
                this.loading = true;
                this.activateUserToken();
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        showPassword() {
            var x = document.getElementById("password1");
            var y = document.getElementById("password2");
            if (x.type === "password") {
              x.type = "text";
              y.type = "text";
            } else {
              x.type = "password";
              y.type = "password";
            }
        },

        reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        
        login(){
            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            }

            let navi = this.$router;
            if(credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name); 
                        localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                        localStorage.setItem("sp_token_key", data.user_token_key); 
                        navi.push('/account');
                    }else{
                        // toastr.warning("invalid login credentials", 'Warning!'); 
                        this.data_error_message = "invalid login credentials";
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                  //  console.log(err)
                    // toastr.warning("invalid login credentials", 'Warning!'); 
                    this.data_error_message = "Sorry, could not process request";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                })
                    
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },

        activateUserToken(){
            let navi = this.$router;
            service.activateUserToken(this, this.$route.params.activatetoken).then(response => {
                if(response.body.status == 200) {
                    this.data_processing_message = "Your Account Activation was successful. redirecting....";
                }else{
                    this.data_processing_message = "Your Account Activation was not successful, please try again. redirecting....";
                }
                setTimeout(function(){ navi.push('/');}, 5250)
            }).catch((err) => {
                this.data_processing_message = "Your Account Activation was not successful, please try again. redirecting....";
                setTimeout(function(){ navi.push('/');}, 5250)
            })
        },

        forgot(){
            this.data_processing_message = "";
            this.activate_processing();
            var credentials = {
                user_email: this.user.email,
            }

            let navi = this.$router;
            if(credentials.user_email) {
                service.forgotPassword(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.set_cta =  true; 
                        this.data_processing_message = "Request was successful, please check your email for a link to reset password";
                    }
                    if(response.body.status == 404) {
                        this.data_processing_message = "Could not find this email";
                    }
                    if(response.body.status == 400) {
                        this.data_processing_message = "Request could not be completed, please try again";
                    }
                    this.deactivate_processing();
                }).catch((err) => {
                    this.data_processing_message = "Request could not be completed, please try again";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = "Please enter your email";
                tthis.deactivate_processing();
            }
        },

        verifyResetToken(){
            service.verifyResetPasswordToken(this, this.$route.params.resettoken).then(response => {
                if(response.body.status == 200) {
                    // this.display_reset_password_form =  true; 
                    this.loading = false;
                    this.user.email = response.body.data; //save the email
                }else{
                    this.data_processing_message = "Password reset failed, please reset againj";
                    this.reset_password = false;
                    this.set_forgot_password = true;
                }
               this.deactivate_processing();
            }).catch((err) => {
                this.data_processing_message = "Password reset failed, please reset againn";
                this.reset_password = false;
                this.set_forgot_password = true;
                this.loading = false;
            })
        },

        resetForgotPassword(){
            this.data_processing_message = "";
            //check passwords
            if((this.user.new_password != '') && (this.user.new_password != undefined)) {
                if(this.user.new_password != this.user.confirm_password){
                    this.data_processing_message = "Passwords does not match";
                }else{
                    this.activate_processing();
                    var credentials = {
                        user_email:this.user.email,
                        new_password: this.user.new_password,
                    }

                    let navi = this.$router;
                
                    service.resetForgotPassword(this, credentials).then(response => {
                        if(response.body.status == 200) {
                            this.data_processing_message = "Password Request was successful";
                            this.user.password = this.user.new_password;
                            this.loading = true; //prep login
                            let self = this;
                            setTimeout(function(){ 
                                //login
                                self.login();
                            }, 6750)
                        }else{
                            this.data_processing_message = "Request could not be completed, please try again";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        this.data_processing_message = "Request could not be completed, please try again";
                        this.deactivate_processing();
                    })
                }
            }else {
                this.data_processing_message = "Please enter passwords";
            }
        },
    },
    created: function(){
        this.reset();
        //check for activate token
        if(this.$route.params.activatetoken){
            this.setComponent("activate","");
        }
        //check for reset token
        if(this.$route.params.resettoken){
            this.setComponent("reset","");
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Login/script.js